module.exports = __webpack_public_path__ + "static/assets/434b394d4c8c49d2d1c18f381e1da7bb.png";